"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleOutlined = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CircleOutlined = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm18 0a8 8 0 10-16 0 8 8 0 0016 0z", clipRule: "evenodd" })); };
exports.CircleOutlined = CircleOutlined;
//# sourceMappingURL=circle-outlined.js.map